import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
})
export class FilterPipe implements PipeTransform {
    public transform(value: any, input: string, term: any) {
        if (input) {
            input = input.toLowerCase();

            return value.filter((item: any) => {
                if (item[term] && item[term].toLowerCase().indexOf(input) > -1) {
                    return item;
                }
            });
        } else {
            return value;
        }
    }
}